import VendorBillPage from "./VendorBillPage";

export default function GeneralPaymentPage() {
  return (
    <VendorBillPage
      moduleKey="general-payment"
      moduleName="general_payment"
      title="General Payment"
      route="general-payments"
      columns={[
        { field: "expense_head",     label: "Expense Head",         placeholder: "e.g. Vehicle Hire / Security" },
        { field: "reporting_period", label: "Reporting Period",     type: "month" },
        { field: "ref_no",           label: "Invoice / Ref No",     placeholder: "e.g. INV/2026/045" },
      ]}
    />
  );
}
